module.exports = __webpack_public_path__ + "img/naverplace.152f12cc.png";